$(document).ready(function(){
	$('a[href^="#"]').click(function(){
		var the_id = $(this).attr("href");
		var $headerH = $('.header').outerHeight();
		$('html, body').animate({
			scrollTop:$(the_id).offset().top - $headerH
		}, 'slow');
		$(the_id).focus();
		return false;
	});
});

